// src/pages/HistorialEconomico.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import Topbar from '../components/Topbar';
import Breadcrumb from '../components/Breadcrumb';
import '../styles/HistorialEconomico.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

export default function HistorialEconomico() {
  const [resultados, setResultados] = useState([]);
  const { expediente } = useParams();
  const history = useHistory();
  const [actuaciones, setActuaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [seleccionados, setSeleccionados] = useState([]);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [tratamientosDisponibles, setTratamientosDisponibles] = useState([]);
  const [paciente, setPaciente] = useState(null);
  
  const calcularTotalFila = (act) => {
    const cantidad = Number(act.cantidad || 1);
    const importe = Number(act.importe || 0);
    const pendiente = Number(act.pendiente_pago || 0);

    if (act.pagado || pendiente > 0) {
      return Math.max((cantidad * importe) - pendiente, 0);
    }

    if (pendiente > 0) {
      return pendiente;
    }

    return null;
  };

  const totalGlobal = actuaciones.reduce((acc, act) => {
    const totalFila = calcularTotalFila(act);
    return acc + (totalFila ?? 0);
  }, 0);

  useEffect(() => {
    async function fetchPaciente() {
      try {
        const { data } = await axios.get(`/api/pacientes/${expediente}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        setPaciente(data);
      } catch (err) {
        console.error("Error al cargar paciente:", err);
      }
    }

    fetchPaciente();
  }, [expediente]);

  useEffect(() => {
    async function fetchHistorial() {
      try {
        const { data } = await axios.get(
          `/api/actuaciones/paciente/${expediente}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
        setResultados(data);
        setActuaciones(data);
      } catch (err) {
        console.error('Error al cargar historial', err.response || err);
      } finally {
        setLoading(false);
      }
    }

    fetchHistorial();
  }, [expediente]);


  useEffect(() => {
  async function fetchTratamientos() {
    try {
      const { data } = await axios.get('/api/tratamientos', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      const opciones = data.map(t => ({
        value: t.nTratamiento,
        label: t.denominacion
      }));
      setTratamientosDisponibles(opciones);
    } catch (err) {
      console.error('Error al cargar tratamientos', err.response || err);
    }
  }

    fetchTratamientos();
  }, []);

  if (loading) return <p>Cargando historial económico...</p>;
  return (
    <>
      <ToastContainer />
      <Topbar />
      <div className="historial-economico-page">
      <Breadcrumb />
        <h2>
          Historial económico de{" "}
          {paciente
            ? [paciente.nombre, paciente.primer_apellido, paciente.segundo_apellido]
                .filter(Boolean)        
                .join(" ")
            : expediente}
        </h2>
        <table className="historial-table">
            <thead>
              <tr>
                  <th>ID</th>
                  <th>Día</th>
                  <th>Tratamiento</th>
                  <th>Pieza</th>
                  <th>Realizado</th>
                  <th>Pagado</th>
                  <th>Facturado</th>
                  <th>Importe</th>
                  <th>Pendiente</th>
              </tr>
            </thead>
            <tbody>
              {actuaciones.map(act => {
                const enEdicion = modoEdicion && seleccionados.includes(act.id);
                return (
                  <tr key={act.id}>                
                    <td>{act.id}</td>
                    <td>{act.dia}</td>
                    <td>{tratamientosDisponibles.find(t => t.value === act.tratamiento)?.label || act.tratamiento}</td>
                    <td>{act.n_pieza}</td>
                    <td>
                      <span className={act.realizado ? 'color-si' : 'color-no'}>
                          {act.realizado ? 'Sí' : 'No'}
                      </span>
                    </td>
                    <td>
                      <span className={act.pagado ? 'color-si' : 'color-no'}>
                          {act.pagado ? 'Sí' : 'No'}
                      </span>
                    </td>
                    <td>
                      <span className={act.n_factura ? 'color-si' : 'color-no'}>
                        {act.n_factura ? 'Sí' : 'No'}
                      </span>
                    </td>
                    <td>{act.importe}</td>
                    <td>{act.pendiente_pago} </td>  
                    <td>
                      {calcularTotalFila(act) !== null
                        ? `${calcularTotalFila(act).toFixed(2)} €`
                        : ""}
                    </td>            
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan={9} style={{ textAlign: "right", fontWeight: "bold" }}>Total:</td>
                     <td style={{ fontWeight: "bold" }}>{totalGlobal.toFixed(2)} €</td>

                </tr>
            </tfoot>
        </table>      
        <div className="acciones-inferiores">
          <button
            className="volver-btn"
            onClick={() => history.push(`/pacientes/${expediente}`)}
          >
            Volver al paciente
          </button>
        </div>
      </div>
    </>
  );
}
